import * as THREE from 'three'

export const SCENE_LIGHTING = {
  exposure: 1.1,
  environmentIntensity: 0.85,
  ambient: 0.45,
  hemisphere: 0.6,
  key: 0.8,
  fill: 0.65,
  rim: 0.2,
}

export function addBalancedSceneLights(scene: THREE.Scene) {
  const { ambient, hemisphere, key, fill, rim } = SCENE_LIGHTING

  scene.add(new THREE.AmbientLight(0xffffff, ambient))
  scene.add(new THREE.HemisphereLight(0xffffff, 0x9a9a9a, hemisphere))

  const keyLight = new THREE.DirectionalLight(0xffffff, key)
  keyLight.position.set(12, 18, 10)
  scene.add(keyLight)

  const fillLight = new THREE.DirectionalLight(0xffffff, fill)
  fillLight.position.set(-12, 14, -8)
  scene.add(fillLight)

  const rimLight = new THREE.DirectionalLight(0xffffff, rim)
  rimLight.position.set(0, 8, -18)
  scene.add(rimLight)
}
